export default function AboutSection() {
  return (
    <section id="about" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            关于甜柚
          </h2>

          <div className="mt-8 p-8 rounded-2xl bg-background-50 border border-background-200/70 text-left">
            <p className="text-sm text-foreground-600 leading-relaxed">
              甜柚漫画创立于对甜蜜恋爱故事的无限热爱。我们相信每一个少女心中都有一个粉红色的梦，
              而漫画正是这个梦最美的载体。甜柚漫画汇聚了海量甜宠恋爱、治愈校园纯爱和少女漫画作品，
              涵盖日漫、韩漫等多元风格，为每一位热爱甜蜜故事的读者提供一个温暖纯粹的阅读空间。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mt-4">
              我们坚持完全免费的阅读模式，让甜蜜故事触手可及。无论是霸总甜宠的浪漫、校园纯爱的青涩，
              还是治愈漫画的温暖——在甜柚漫画，总有一段故事会让你心动不已。好看停不下来，这是我们的承诺。
            </p>
            <div className="mt-6 flex flex-wrap gap-4">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                2000+部漫画作品
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                每日稳定更新
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                完全免费阅读
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                正版授权内容
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}